import { DAY_PART_SELECTIONS } from 'constants/menu';

import { ItemAvailabilityStatus } from 'enums/menu';
import { EntryTypeEnum, IEntryReferenceDto } from 'generated/graphql-gateway';
import { IDayPartBoundary } from 'state/menu/main-menu/types';
import { ILocalizedMenuEntry, PosServiceMode } from 'state/unified-menu/types';

export const getOneMenuAvailability = (
  item: ILocalizedMenuEntry | undefined,
  activeDayParts: IDayPartBoundary[],
  posServiceMode: PosServiceMode,
  storeHasBurgersForBreakfast: boolean,
  isEntryAvailable: (
    entry: ILocalizedMenuEntry | IEntryReferenceDto,
    posServiceMode: PosServiceMode,
    dayPartIds?: string[]
  ) => boolean
): ItemAvailabilityStatus => {
  if (!item) {
    return ItemAvailabilityStatus.OUT_OF_MENU;
  }

  const isModifier = item.type === EntryTypeEnum.MODIFIER;
  const isAvailableForActiveDayParts =
    isModifier || activeDayParts?.some(({ key }) => item.dayParts?.includes(key));

  if (!isAvailableForActiveDayParts) {
    return ItemAvailabilityStatus.OUT_OF_DAYPART;
  }

  /**
   * null or true availability means it is available
   */
  const available = isEntryAvailable(item, posServiceMode, undefined);
  if (!available) {
    return ItemAvailabilityStatus.UNAVAILABLE;
  }

  if (isModifier) {
    return ItemAvailabilityStatus.AVAILABLE;
  }

  const isBurgerForBreakfastDaypartActive = activeDayParts?.some(
    ({ key }) => key === DAY_PART_SELECTIONS.BURGERS_FOR_BREAKFAST
  );

  const itemHasBurgerForBreakfast = item.dayParts?.includes(
    DAY_PART_SELECTIONS.BURGERS_FOR_BREAKFAST
  );

  if (
    itemHasBurgerForBreakfast &&
    isBurgerForBreakfastDaypartActive &&
    !storeHasBurgersForBreakfast
  ) {
    return ItemAvailabilityStatus.OUT_OF_DAYPART;
  }

  return ItemAvailabilityStatus.AVAILABLE;
};
